export default {
  "content": "<path d=\"M16 16.733l7.294-5.674A.992.992 0 0023 11H9c-.1.005-.2.024-.294.059L16 16.733z\" fill=\"#fff\"/><path d=\"M16.614 18.79a1 1 0 01-1.228 0L8 13.045V20a1 1 0 001 1h14a1 1 0 001-1v-6.955l-7.386 5.745z\" fill=\"#fff\"/>",
  "attrs": {
    "width": "32",
    "height": "32",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};